/**
 * Created with IntelliJ IDEA.
 * User: danielg
 * Date: 3/10/14
 * Time: 2:48 PM
 * To change this template use File | Settings | File Templates.
 */
define(function (require) {

    var _ = require('underscore');
    var leConf = require("assets/config/le-env-conf");

    var AgentLEManager = (function () {

        function getLE() {
            return require('app');
        }

        function getLEVent() {
            return getLE().vent;
        }

        function getLEContext() {
            return getLE().context;
        }

        function getLEConst() {
            return getLE().CONST;
        }

        function getLEContextAttributes() {
            return getLEContext().attributes;
        }

        function getLETranslator() {
            return getLE().translator;
        }

        function getLESessionManager() {
            return getLE().sessionManager;
        }

        function getLELocaleResolver() {
            return getLE().localeResolver;
        }

        function getLEWebAgent() {
            return getLE().LEWebAgent;
        }

        function getLEWebAgentLogger() {
            return getLEWebAgent().logger;
        }

        function getLEWebAgentChannel() {
            return getLEWebAgent().channel;
        }

        function getLEWebAgentNotifier() {
            return getLEWebAgent().notifier;
        }

        function getLEMediaCodes() {
            return getLE().mediaCodes;
        }

        function getLEUserBarMenu() {
            return getLE().userBarMenu;
        }

        function getLEUrlResolver() {
            return getLE().urlResolver;
        }

        function getLENotificationCenter() {
            return getLE().notificationCenter;
        }

        function checkLEVent() {
            return !!getLE() && !!getLEVent();
        }

        function checkLEVentTrigger() {
            return checkLEVent() && !!(getLEVent().trigger);
        }

        function checkLEVentOn() {
            return checkLEVent() && !!(getLEVent().on);
        }

        function checkLEVentOff() {
            return checkLEVent() && !!(getLEVent().off);
        }

        function checkLEVentOnce() {
            return checkLEVent() && !!(getLEVent().once);
        }

        function checkLEContext() {
            return !!getLE() && !!getLEContext();
        }

        function checkLEConst() {
            return !!getLE() && !!getLEConst();
        }

        function checkLEContextAttribute(contextItem) {
            return checkLEContext() && !!getLEContextAttributes() && !!(getLEContextAttributes()[contextItem]);
        }

        function checkLEContextBind() {
            return checkLEContext() && !!(getLEContext().bind);
        }

        function checkLEContextSet() {
            return checkLEContext() && !!(getLEContext().set);
        }

        function checkLETranslator() {
            return !!getLE() && !!getLETranslator();
        }

        function checkLETranslatorTranslate() {
            return checkLETranslator() && !!(getLETranslator().translate);
        }

        function checkLETranslatorHasTranslationKey() {
            return checkLETranslator() && !!(getLETranslator().hasTranslationKey);
        }

        function checkLESessionManager() {
            return !!getLE() && !!getLESessionManager();
        }

        function checkLESessionManagerHasPrivilege() {
            return checkLESessionManager() && !!(getLESessionManager().hasPrivilege);
        }

        function checkLESessionManagerGetGlob() {
            return checkLESessionManager() && !!(getLESessionManager().getGlob);
        }

        function checkLESessionManagerGetAccountId() {
            return checkLESessionManager() && !!(getLESessionManager().getAccountId);
        }

        function checkLESessionManagerGetAccountSettingById() {
            return checkLESessionManager() && !!(getLESessionManager().getAccountSettingByID);
        }

        function checkLESessionManagerGetAccountSettingValueById() {
            return checkLESessionManager() && !!(getLESessionManager().getAccountSettingValueByID);
        }

        function checkLESessionManagerGetFeatureProperty() {
            return checkLESessionManager() && !!(getLESessionManager().getFeatureProperty);
        }

        function checkLESessionManagerHasLiveEngage2Feature() {
            return checkLESessionManager() && !!(getLESessionManager().hasLiveEngage2Feature);
        }

        function checkLESessionManagerHasAgentGroupsFeature() {
            return checkLESessionManager() && !!(getLESessionManager().hasAgentGroupsFeature);
        }

        function checkLESessionManagerHasVisitorFeedPreFiltering() {
            return checkLESessionManager() && !!(getLESessionManager().hasVisitorFeedPreFiltering);
        }

        function checkLESessionManagerHasDataEncryptionFeature() {
            return checkLESessionManager() && !!(getLESessionManager().hasDataEncryptionDataFeature);
        }

        function checkLESessionManagerHasPersona() {
            return checkLESessionManager() && !!(getLESessionManager().hasPersona);
        }

        function checkLESessionManagerGetConfig() {
            return checkLESessionManager() && !!(getLESessionManager().getConfig);
        }

        function checkLESessionManagerGetAgentGroupsData() {
            return checkLESessionManager() && !!(getLESessionManager().getAgentGroupsData);
        }

        function checkLELocaleResolver() {
            return !!getLE() && !!getLELocaleResolver();
        }

        function checkLEIsFirstTimeLogin() {
            return !!getLE() && !!(getLE().isFirstTimeLogin);
        }

        function checkLEModule() {
            return !!getLE() && !!(getLE().module);
        }

        function checkLEVersion() {
            return !!getLE() && !!(getLE().version);
        }

        function checkLEWebAgent() {
            return !!getLE() && !!getLEWebAgent();
        }

        function checkLEWebAgentLogger() {
            return checkLEWebAgent() && !!getLEWebAgentLogger();
        }

        function checkLEWebAgentChannel() {
            return checkLEWebAgent() && !!getLEWebAgentChannel();
        }

        function checkLEWebAgentNotifier() {
            return checkLEWebAgent() && !!getLEWebAgentNotifier();
        }

        function checkLEWebAgentLoggerError() {
            return checkLEWebAgentLogger() && !!(getLEWebAgentLogger().error);
        }

        function checkLEMediaCodes() {
            return !!getLE() && !!getLEMediaCodes();
        }

        function checkLEUserBarMenu() {
            return !!getLE() && !!getLEUserBarMenu();
        }

        function checkLEUserBarMenuRemoveTrayItem() {
            return checkLEUserBarMenu() && !!(getLEUserBarMenu().removeTrayItem);
        }

        function checkLEUserBarMenuAddTrayItem() {
            return checkLEUserBarMenu() && !!(getLEUserBarMenu().addTrayItem);
        }

        function checkLEUserBarMenuAddMenuItem() {
            return checkLEUserBarMenu() && !!(getLEUserBarMenu().addMenuItem);
        }

        function checkLEUserBarMenuAddStatusItem() {
            return checkLEUserBarMenu() && !!(getLEUserBarMenu().addStatusItem);
        }

        function checkLEUserBarMenuSetCurrentStatusItem() {
            return checkLEUserBarMenu() && !!(getLEUserBarMenu().setCurrentStatusItem);
        }

        function checkLEMediaCodesWebAgent() {
            return checkLEMediaCodes() && !!getLEMediaCodes().webAgent;
        }

        function checkLEUrlResolver() {
            return !!getLE() && !!getLEUrlResolver();
        }

        function checkLEUrlResolverGetConfigValue() {
            return checkLEUrlResolver() && !!(getLEUrlResolver().getConfigValue);
        }

        function checkLEUrlResolverGetUrl() {
            return checkLEUrlResolver() && !!(getLEUrlResolver().getUrl);
        }

        function checkLEUrlResolverApiResource(contextItem) {
            return checkLEUrlResolver() && !!(getLEUrlResolver().apiResources) && !!(getLEUrlResolver().apiResources[contextItem]);
        }

        function checkLENotificationCenter() {
            return !!getLE() && !!getLENotificationCenter();
        }

        function checkLENotificationCenterNotify() {
            return checkLENotificationCenter() && !!(getLENotificationCenter().notify);
        }

        function checkLENotificationCenterClearNotification() {
            return checkLENotificationCenter() && !!(getLENotificationCenter().clearNotification);
        }

        function getMcsAgentViewIndication() {
            return getLE() && getLE().siteSettings && getLE().siteSettings.agentStatusSettings && getLE().siteSettings.agentStatusSettings.getMcsAgentViewIndication();
        }

        function getSupportedLanguageSettings() {
            return getLE() && getLE().siteSettings && getLE().siteSettings.supportedLanguageSettings;
        }

        function getCurrencySettings() {
            return getLE() && getLE().siteSettings && getLE().siteSettings.currencySettings;
        }

        function getAgentOutComeSettings() {
            return getLE() && getLE().siteSettings && getLE().siteSettings.agentOutcomeSettings && getLE().siteSettings.agentOutcomeSettings.getAgentOutcome();
        }

        function getRouter() {
            return getLE() && getLE().LEWebAgent && getLE().LEWebAgent.router;
        }

        function getNavigator() {
            return getLE() && getLE().navigator;
        }

        function getLEConfiguration() {
            return leConf;
        }

        function getCSDSRecord(csdsKey) {
            if (getLESessionManager() && getLESessionManager().getCsdsResponse() && getLESessionManager().getCsdsResponse().baseURIs) {
                return _.find(getLESessionManager().getCsdsResponse().baseURIs, function (item) {
                    return item.service === csdsKey;
                });
            }
        }

        function checkAIAssistWidgetFeature() {
          return (
            getLESessionManager() &&
            typeof getLESessionManager().hasAIAssistWidgetFeature === 'function'
          );
        }

        function getAIAssistWidgetFeature() {
          return getLESessionManager().hasAIAssistWidgetFeature();
        }

        var agentLEManager = {
            getLEConfig: function () {
                return getLEConfiguration();
            },
            isInLE: function () {
                return checkLEVent();
            },
            triggerLEEvent: function (eventName, eventData) {
                if (checkLEVentTrigger()) {
                    getLEVent().trigger(eventName, eventData);
                }
            },
            onLEEvent: function (eventName, callback, context) {
                if (checkLEVentOn()) {
                    getLEVent().on(eventName, callback, context);
                }
            },
            offLEEvent: function (eventName, callback, context) {
                if (checkLEVentOff()) {
                    getLEVent().off(eventName, callback, context);
                }
            },
            onceLEEvent: function (eventName, callback, context) {
                if (checkLEVentOnce()) {
                    getLEVent().once(eventName, callback, context);
                }
            },
            getLEValue: function (contextItem, variable) {
                var result = null;
                if (checkLEContext() && getLEContext()[contextItem]) {
                    result = getLEContext()[contextItem][variable];
                }
                return result;
            },
            getLEConst: function () {
                var result = null;
                if (checkLEConst()) {
                    result = getLEConst();
                }
                return result;
            },
            getLEAttributeValue: function (contextItem, variable) {
                var result = null;
                if (checkLEContextAttribute(contextItem)) {
                    result = getLEContextAttributes()[contextItem][variable];
                }
                return result;
            },
            bindToLEValue: function (variable, callback) {
                if (checkLEContextBind()) {
                    getLEContext().bind(variable, callback);
                }
            },
            setLEValue: function (variable, value) {
                if (checkLEContextSet()) {
                    getLEContext().set(variable, value);
                }
            },
            translateLE: function (key, locale) {
                var result = "";
                if (checkLETranslatorTranslate()) {
                    result = getLETranslator().translate(key, locale);
                } else {
                    var stringKey = key.toString();
                    if (stringKey.indexOf("LEWebAgent.") === 0) {
                        stringKey = stringKey.substring("LEWebAgent.".length);   //no "LEWebAgent" in standalone
                    }
                    if (window.dictionary && window.dictionary[stringKey]) {
                        result = window.dictionary[stringKey];
                    }
                }
                return result;
            },
            hasLETranslationKey: function (key, locale) {
                var result = false;
                if (checkLETranslatorHasTranslationKey()) {
                    result = getLETranslator().hasTranslationKey(locale || 'en-US', key);
                } else {
                    var stringKey = key.toString();
                    if (stringKey.indexOf("LEWebAgent.") === 0) {
                        stringKey = stringKey.substring("LEWebAgent.".length);   //no "LEWebAgent" in standalone
                    }
                    if (window.dictionary) {
                        result = window.dictionary.hasOwnProperty(stringKey);
                    }
                }
                return result;
            },
            hasLEPrivilege: function (privilegeId) {
                var result = true;
                if (checkLESessionManagerHasPrivilege()) {
                    result = getLESessionManager().hasPrivilege(privilegeId);
                }
                return result;
            },
            hasPersona: function (persona) {
                var result = true;
                if (checkLESessionManagerHasPersona()) {
                    result = getLESessionManager().hasPersona(persona);
                }
                return result;
            },
            isFirstTimeLELogin: function () {
                var result = false;
                if (checkLEIsFirstTimeLogin()) {
                    result = getLE().isFirstTimeLogin();
                }
                return result;
            },
            moduleLE: function (module, callback) {
                var result = null;
                if (checkLEModule()) {
                    result = getLE().module(module, callback);
                }
                return result;
            },
            versionLE: function () {
                var result = 0;
                if (checkLEVersion()) {
                    result = getLE().version;
                }
                return result;
            },
            loggerLE: function () {
                var result = null;
                if (checkLEWebAgentLogger()) {
                    result = getLEWebAgentLogger();
                }
                return result;
            },
            channelLE: function () {
                var result = null;
                if (checkLEWebAgentChannel()) {
                    result = getLEWebAgentChannel();
                }
                return result;
            },
            notifierLE: function () {
                var result = null;
                if (checkLEWebAgentNotifier()) {
                    result = getLEWebAgentNotifier();
                }
                return result;
            },
            loggerLEError: function (message) {
                if (checkLEWebAgentLoggerError()) {
                    getLEWebAgentLogger().error(message);
                }
            },
            getGlobLE: function () {
                var result = null;
                if (checkLESessionManagerGetGlob()) {
                    result = getLESessionManager().getGlob();
                }
                return result;
            },
            getAccountIdLE: function () {
                var result = null;
                if (checkLESessionManagerGetAccountId()) {
                    result = getLESessionManager().getAccountId();
                }
                return result;
            },
            getAccountSettingByIdLE: function (item) {
                var result = null;
                if (checkLESessionManagerGetAccountSettingById()) {
                    result = getLESessionManager().getAccountSettingByID(item);
                }
                return result;
            },
            getAccountSettingValueByIdLE: function (item) {
                var result = null;
                if (checkLESessionManagerGetAccountSettingValueById()) {
                    result = getLESessionManager().getAccountSettingValueByID(item);
                }
                return result;
            },
            getFeatureProperty: function (key) {
                var result = null;
                if (checkLESessionManagerGetFeatureProperty()) {
                    var featureProperty = getLESessionManager().getFeatureProperty(key);
                    if (typeof featureProperty !== 'undefined' &&
                        typeof featureProperty.value !== 'undefined') {
                        result = featureProperty.value.value;
                    }
                }
                return result;
            },
            getSessionConfig: function () {
                var result = null;
                if (checkLESessionManagerGetConfig()) {
                    result = getLESessionManager().getConfig();
                }
                return result;
            },
            getAgentGroupsData: function () {
                var result = null;
                if (checkLESessionManagerGetAgentGroupsData()) {
                    result = getLESessionManager().getAgentGroupsData();
                }
                return result;
            },
            hasLiveEngage2Feature: function () {
                var result = null;
                if (checkLESessionManagerHasLiveEngage2Feature()) {
                    result = getLESessionManager().hasLiveEngage2Feature();
                }
                return result;
            },
            hasDataEncryptionFeature: function () {
                var result = null;
                if (checkLESessionManagerHasDataEncryptionFeature()) {
                    result = getLESessionManager().hasDataEncryptionDataFeature();
                }
                return result;
            },
            hasAgentGroupsFeature: function () {
                var result = null;
                if (checkLESessionManagerHasAgentGroupsFeature()) {
                    result = getLESessionManager().hasAgentGroupsFeature();
                }
                return result;
            },
            hasVisitorFeedPreFiltering: function () {
                var result = null;
                if (checkLESessionManagerHasVisitorFeedPreFiltering()) {
                    result = getLESessionManager().hasVisitorFeedPreFiltering();
                }
                return result;
            },
            getLEUserBarModel: function (modelName) {
                var result = null;
                if (checkLEUserBarMenu()) {
                    result = getLEUserBarMenu()[modelName];
                }
                return result;
            },
            getConversationOutcomes: function (agentSkills) {
                var outcomeSettings = getAgentOutComeSettings(),
                    agentSetting = {},
                    hasProps = false,
                    tempSkillId;


                if (_.isArray(agentSkills)) {//Why why why...can't we all be friends and consistent? string !== number - ARGHHHHHHHHHHHHHHHHH
                    for (var i = 0; i < agentSkills.length; i++) {
                        tempSkillId = parseInt(agentSkills[i].id, 10);
                        if (!isNaN(tempSkillId)) {
                            agentSkills[i].id = tempSkillId;
                        }
                    }
                }

                for (var key in outcomeSettings) {
                    if (outcomeSettings.hasOwnProperty(key)) {
                        if (!outcomeSettings[key].skills || 0 === outcomeSettings[key].skills.length) {
                            agentSetting[key] = JSON.parse(JSON.stringify(outcomeSettings[key]));
                            hasProps = true;
                        } else {
                            for (var j = 0; j < agentSkills.length; j++) {
                                if (outcomeSettings[key].skills.indexOf(agentSkills[j].id) > -1) {
                                    agentSetting[key] = JSON.parse(JSON.stringify(outcomeSettings[key]));
                                    hasProps = true;
                                }
                            }
                        }
                    }
                }
                return hasProps ? agentSetting : null;
            },
            removeLEUserBarTrayItem: function (item) {
                if (checkLEUserBarMenuRemoveTrayItem()) {
                    getLEUserBarMenu().removeTrayItem(item);
                }
            },
            addLEUserBarTrayItem: function (item, index) {
                if (checkLEUserBarMenuAddTrayItem()) {
                    getLEUserBarMenu().addTrayItem(item, index);
                }
            },
            addLEUserBarMenuItem: function (item, index) {
                if (checkLEUserBarMenuAddMenuItem()) {
                    getLEUserBarMenu().addMenuItem(item, index);
                }
            },
            addLEUserBarStatusItem: function (item, index) {
                if (checkLEUserBarMenuAddStatusItem()) {
                    getLEUserBarMenu().addStatusItem(item, index);
                }
            },
            setLEUserBarCurrentStatusItem: function (currentStatusItem, reasonId) {
                if (checkLEUserBarMenuSetCurrentStatusItem()) {
                    getLEUserBarMenu().setCurrentStatusItem(currentStatusItem, reasonId);
                }
            },
            getLELocaleResolverLocale: function () {
                var result = null;
                if (checkLELocaleResolver()) {
                    result = getLELocaleResolver().getLocale();
                }
                return result;
            },
            getLEUrlResolverConfigValue: function (key) {
                var result = null;
                if (checkLEUrlResolverGetConfigValue()) {
                    result = getLEUrlResolver().getConfigValue(key);
                }
                return result;
            },
            getLEMediaCodesWebAgent: function () {
                var result = null;
                if (checkLEMediaCodesWebAgent()) {
                    result = getLEMediaCodes().webAgent;
                }
                return result;
            },
            getLEUrlResolverGetUrl: function (key) {
                var result = null;
                if (checkLEUrlResolverGetUrl()) {
                    result = getLEUrlResolver().getUrl(key);
                }
                return result;
            },
            getLEUrlResolverGetUrlParts: function (key) {
                var result = null;
                if (checkLEUrlResolverGetUrl()) {
                    result = getLEUrlResolver().getUrlParts(key);
                }
                return result;
            },
            getLEUrlResolverApiResourcesService: function (key) {
                var result = null;
                if (checkLEUrlResolverApiResource(key)) {
                    result = getLEUrlResolver().apiResources[key];
                }
                return result;
            },
            getMcsAgentViewIndication: function () {
                var result = null;
                if (getMcsAgentViewIndication()) {
                    result = getMcsAgentViewIndication();
                }
                return result;
            },
            notificationCenterNotify: function (options) {
                var result = null;
                if (checkLENotificationCenterNotify()) {
                    result = getLENotificationCenter().notify(options);
                }
                return result;
            },
            notificationCenterClearNotification: function (options) {
                var result = null;
                if (checkLENotificationCenterClearNotification()) {
                    result = getLENotificationCenter().clearNotification(options);
                }
                return result;
            },
            getSupportedLanguageCodes: function () {
                var retVal;
                var supportedLanguagesSettings = getSupportedLanguageSettings();
                if (supportedLanguagesSettings) {
                    retVal = supportedLanguagesSettings.getSupportedLanguageCodes();
                }
                return retVal;
            },
            getDefaultLanguage: function () {
                var retVal;
                var supportedLanguagesSettings = getSupportedLanguageSettings();
                if (supportedLanguagesSettings) {
                    retVal = supportedLanguagesSettings.getDefaultLanguage();
                }
                return retVal;
            },
            getCurrentCurrencyObject: function () {
                var retVal;
                var currencySettings = getCurrencySettings();
                if (currencySettings) {
                    retVal = currencySettings.getCurrentCurrencyObject();
                }
                return retVal;
            },
            getCurrencyList: function () {
                var retVal;
                var currencySettings = getCurrencySettings();
                if (currencySettings) {
                    retVal = currencySettings.getCurrencyList();
                }
                return retVal;
            },
            navigate: function (url) {
                var router = getRouter();
                if (router) {
                    return router.navigate(url);
                }
            },
            getModelRoute: function () {
                var navigator = getNavigator();
                if (navigator) {
                    return navigator.getFragment();
                }
            },
            getCSDSRecord: function (serviceKey) {
                return getCSDSRecord(serviceKey);
            },
            hasAIAssistWidgetFeature: function() {
              var result = null;
              if (checkAIAssistWidgetFeature()) {
                result = getAIAssistWidgetFeature();
              }
              return result;
            }
        };
        return agentLEManager;
    })();

    return AgentLEManager;

});
